export default __webpack_public_path__ + "static/media/star-city.97ac5870.png";